import { useEffect, useState } from 'react'

/* Shared by the Intelligence Hub banners */

export const prefersReducedMotion = () =>
  typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches

/* counts a number up from 0 after a delay, easing out; instant with reduced motion */
export const useCountUp = (target: number | undefined, delayMs: number, durationMs = 1400): number | undefined => {
  const [value, setValue] = useState(0)
  useEffect(() => {
    if (target === undefined) return undefined
    if (prefersReducedMotion() || typeof window.requestAnimationFrame !== 'function') {
      setValue(target)
      return undefined
    }
    const start = performance.now() + delayMs
    let raf = 0
    const tick = (now: number) => {
      const u = Math.min(1, Math.max(0, (now - start) / durationMs))
      setValue(target * (1 - (1 - u) ** 3))
      if (u < 1) raf = window.requestAnimationFrame(tick)
    }
    raf = window.requestAnimationFrame(tick)
    return () => window.cancelAnimationFrame(raf)
  }, [target, delayMs, durationMs])
  return target === undefined ? undefined : value
}
